import { io, Socket } from 'socket.io-client';
import { getEnvs } from '../utils/get-envs';

/* const infoUser = useAuthStore.getState().user

const socket = io(getEnvs().VITE_SOCKET_URL);

export default socket; */

export let socket: Socket | null = null;

export const initializeSocket = (queryParams: Record<string, any>) => {

  if(getEnvs().VITE_NODE_ENV == 'dev') {
    return null
  }

  if (!socket) {
    socket = io(getEnvs().VITE_SOCKET_URL, {
      reconnection: getEnvs().VITE_NODE_ENV == 'prod' ? true : false,  // Asegura que la reconexión esté habilitada
      reconnectionAttempts: getEnvs().VITE_NODE_ENV == 'prod' ? Infinity : 999999,  // Intenta reconectar infinitamente
      reconnectionDelay: getEnvs().VITE_NODE_ENV == 'prod' ? 1000 : 999999,  // Espera 1 segundo entre reconexiones
      reconnectionDelayMax: getEnvs().VITE_NODE_ENV == 'prod' ? 5000 : 999999,  // Tiempo máximo entre reconexiones
      timeout: getEnvs().VITE_NODE_ENV == 'prod' ? 20000 : 999999,
      query: queryParams
    });
  }
  return socket;
};

export const getSocket = () => {
  if (!socket) {
    throw new Error('Socket not initialized. Call initializeSocket first.');
  }
  return socket;
};
